import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import Logo from './Components/LOGO2.png';
import Header from './Components/Header';
import VisitorInfo from './Info';




const VistaGaleria = () => {
    const [allImages, setAllImages] = useState([]);
    const [visibleImages, setVisibleImages] = useState([]);
    const [visibleCount, setVisibleCount] = useState(50);
    const [hoveredImage, setHoveredImage] = useState(null);
    const hoverTimeout = useRef(null);
    const apiUrl = process.env.REACT_APP_API_URL;
    const apiUrlImg = process.env.REACT_APP_URL_IMG;

    useEffect(() => {
        const fetchImages = async () => {
            try {
                const response = await axios.get(apiUrl+`images`);
                setAllImages(response.data.images);
            } catch (error) {
                console.error("Error fetching images", error);
            }
        };

        fetchImages();
    }, []);

    useEffect(() => {
        setVisibleImages(allImages.slice(0, visibleCount));
    }, [allImages, visibleCount]);

    const loadMoreImages = () => {
        setVisibleCount(prevCount => prevCount + 50);
    };

    const handleMouseOver = (image) => {
        clearTimeout(hoverTimeout.current);
        setHoveredImage(image);
    };

    const handleMouseOut = () => {
        hoverTimeout.current = setTimeout(() => {
            setHoveredImage(null);
        }, 1000); // Retraso de 300ms antes de desaparecer la información
    };

    return (
        <div>
            <Header />
            <VisitorInfo page="GALERIA"></VisitorInfo>
            <div className='mt-4 p-2'>
                <div className='ml-6 p-2'>
                <h1 style={{ textAlign: 'start' }}><strong>Galería</strong></h1>
                <p style={{ textAlign: 'start' }}> <strong>Total de imágenes:</strong> {allImages.length}</p>
                </div>

            <div style={{ 
                display: 'flex', 
                flexWrap: 'wrap', 
                justifyContent: 'center' // Esto centra los elementos hijos horizontalmente 
            }}>
                {visibleImages.map((image) => (
                    <div key={image.ima_int_id} 
                         style={{ margin: '10px', position: 'relative' }}
                         onMouseOver={() => handleMouseOver(image)}
                         onMouseOut={handleMouseOut}>
                        <img 
                            src={Logo}
                            data-src={
                                image.ima_txt_urlimages.includes('drive.google.com')
                                  ? `https://lh3.googleusercontent.com/d/${image.ima_txt_urlimages.split('/')[5]}=w1000`
                                  : apiUrlImg + image.ima_txt_urlimages
                              }
                              
                              
                            alt={image.ima_txt_part}
                            style={{ width: '250px', height: '300px' }}
                            loading="lazy"
                            onLoad={(e) => {
                                e.target.src = e.target.dataset.src;
                            }}
                        />
                        {hoveredImage === image && (
                            <div style={{
                                position: 'absolute',
                                bottom: 0,
                                left: 0,
                                background: 'rgba(0,0,0,0.5)',
                                color: 'white',
                                padding: '10px',
                                borderRadius: '5px',
                                transition: 'opacity 0.5s, transform 1.0s',
                                transform: hoveredImage === image ? 'translateY(0)' : 'translateY(100%)',
                                opacity: hoveredImage === image ? 1 : 0,
                            }}>
                                <p>Nombre Común: {image.reg_txt_commonnames}</p>
                                <p>Parte: {image.ima_txt_part}</p>
                                <p>Fecha de Creación: {image.ima_txt_datecreate}</p>
                                <a 
                                    href={`/ficha-arbol/${image.reg_int_id}`}
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    
                                >
                                    <button className='btn btn-success'>
                                        Ver Ficha
                                    </button>
                                </a>
                               
                            </div>
                        )}
                    </div>
                ))}
            </div>
            {visibleCount < allImages.length && (
                <div style={{ textAlign: 'center', margin: '20px' }}>
                    <button onClick={loadMoreImages}>Cargar 50 más</button>
                </div>
            )}
            </div>

        </div>
    );
};

export default VistaGaleria;